























import { Component, Prop, Vue } from "vue-property-decorator";
import { eventService } from "../services/EventService";

@Component({
  components: {}
})
export default class DialogForm extends Vue {
  @Prop({ type: String, default: "DialogForm-Close" })
  closeEvent: any | string;

  @Prop({ type: String, default: "DialogForm-Save" })
  saveEvent: any | string;

  @Prop({ type: Boolean, default: false })
  visible: boolean = false;

  @Prop({ type: String, default: "" })
  nameComponent: any | string;

  @Prop()
  propsComponent: any;


  valid: boolean = false;

  @Prop({ type: String, default: "" })
  title: any | string;

  @Prop({ type: String, default: "Cerrar" })
  closeText: any | string;

  @Prop({ type: String, default: "Guardar" })
  saveText: any | string;

  destroyed(){
    eventService.off(this.closeEvent);
    eventService.off(this.saveEvent);
  }

  created() {

    
  }

  close() {
    eventService.emit(this.closeEvent, null);
  }

  save() {
    eventService.emit(this.saveEvent, null);
  }
}
